// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js_iax/" + chunkId + "." + "b96da64d" + ".chunk.js";
};